import React, { Ref } from 'react'

import { CTAButton } from '../CTAButton/CTAButton'
import { FooterStickyGetStartedTrackingEvent } from '../../tracking/trackingConfig'
import {
  Space,
  Box,
  Display,
  Text,
  FlexDirection,
  AlignItems,
  AlignSelf,
  Icon,
  IconNames,
  Bold,
  JustifyContent,
} from '@gousto-internal/citrus-react'
import { HERO_CONFIG } from '../Hero/Hero.config'
import { GetStartedWrapper } from './GetStarted.styled'

export type GetStartedProps = {
  isHeroCTA: boolean
  isSticky: boolean
  maxHeight: number
  ctaRef?: Ref<HTMLDivElement>
  getStartedText: string
}

export const GetStarted = ({
  isHeroCTA,
  isSticky,
  maxHeight,
  ctaRef,
  getStartedText,
}: GetStartedProps) => {
  const { ariaLabel, iconName, strongText, text } = HERO_CONFIG.benefit[0]

  return (
    <GetStartedWrapper
      isSticky={isSticky}
      maxHeight={maxHeight}
      ctaRef={ctaRef}
      isHeroCTA={isHeroCTA}
      data-testid="StickyCta"
    >
      <CTAButton
        trackingEvent={FooterStickyGetStartedTrackingEvent}
        text={getStartedText}
        maxWidth="100%"
      />
      <Space direction="vertical" size={3} />
      <Box
        role="img"
        aria-label={ariaLabel}
        display={Display.Flex}
        flexDirection={FlexDirection.Row}
        alignItems={AlignItems.Center}
        paddingBottom={2}
        alignSelf={AlignSelf.Start}
        justifyContent={JustifyContent.Center}
      >
        <Icon name={iconName as IconNames} size={6} />
        <Space direction="horizontal" size={2} />
        <Text size={1}>
          <Bold>{strongText}</Bold>
          {text}
        </Text>
      </Box>
    </GetStartedWrapper>
  )
}
